module.exports = __webpack_public_path__ + "img/instagram (1).506c235c.svg";